import { FC } from 'react';

import classNames from 'classnames';
import { ToastContainer as ReactToastContainer } from 'react-toastify';

import './ToastContainer.scss';

import { TestMetadata } from '../types';

export interface ToastContainerProps {
  /** Toast content */
  autoClose?: number | false;
  /** Toast content closeOnClick */
  closeOnClick?: boolean;
  /** Inline */
  inline?: boolean;
  /** enableMultiContainer */
  enableMultiContainer?: boolean;
  /** containerId */
  containerId?: string | number;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
  /** container className */
  className?: string;
  /** Max number of toasts to show at a time */
  limit?: number;
}

const ToastContainer: FC<ToastContainerProps> = ({
  autoClose = 3000,
  closeOnClick = false,
  inline = false,
  enableMultiContainer = false,
  containerId,
  className,
  testMetadata,
  limit,
  ...otherProps
}) => {
  return (
    <ReactToastContainer
      {...otherProps}
      autoClose={autoClose}
      closeButton={false}
      bodyClassName="sb-toast-container__body"
      toastClassName="sb-toast-container__toast"
      enableMultiContainer={enableMultiContainer}
      hideProgressBar
      closeOnClick={closeOnClick}
      className={classNames({ inline }, className)}
      containerId={containerId}
      draggable={false}
      limit={limit}
      {...testMetadata}
    />
  );
};

export default ToastContainer;
